import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-slurry-cispro-container-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slurry-cispro-container-dialog.component.html'
})
export class SlurryCisproContainerDialogComponent {
  @Input() draftValue = '';

  @Output() closeRequested = new EventEmitter<void>();
  @Output() lookupRequested = new EventEmitter<void>();
  @Output() draftValueChange = new EventEmitter<string>();
  @Output() saveRequested = new EventEmitter<string>();

  clearDraft(): void {
    this.draftValueChange.emit('');
  }

  saveDraft(): void {
    this.saveRequested.emit(this.draftValue);
  }
}
